export function replaceVariables({ value = '', isShow = false, show = '', none = '', type = '' }, source = {}, printData = {}) {
  const regex = /\{\{(\w+)\}\}/g;
  let str = ''
  if (show && printData[show + 'IsShow'] != 'Y') return str
  if (none && printData[none + 'IsShow'] == 'Y') return str
  // 没有权限时，如果只有一个字段，那么整行都消失；否则，只消失本字段
  let matchList = value.match(regex)
  if (type != '' && matchList && matchList.length == 1) {
    let tempStr = matchList[0].replace(/{{(.*?)}}/g, '$1')
    if (isShow) {
      if (printData[tempStr + 'IsShow'] && printData[tempStr + 'IsShow'] == 'Y' && source[tempStr]) {
        str = value.replace(regex, (_, variable) => ['undefined', 'null', undefined, null].includes(source[variable]) ? '' : source[variable])
      }
    } else {
      if (source[tempStr]) {
        str = value.replace(regex, (_, variable) => ['undefined', 'null', undefined, null].includes(source[variable]) ? '' : source[variable])
      }
    }
  } else {
    let flag = (matchList && matchList.every(i => {
      return isShow && printData[i.replace(/{{(.*?)}}/g, '$1') + 'IsShow'] != 'Y'
    })) || false
    if (flag) {
      str = ''
    } else {
      str = value.replace(regex, (_, variable) => {
        if (isShow) {
          if (printData[variable + 'IsShow'] == 'Y') {
            return ['undefined', 'null', undefined, null].includes(source[variable]) ? '' : source[variable]
          } else {
            return ''
          }
        } else {
          return ['undefined', 'null', undefined, null].includes(source[variable]) ? '' : source[variable]
        }
      })
    }
  }
  return str.replaceAll('()', '')
}